module.exports = __webpack_public_path__ + "ffc22b5cc12d49f25214da232d5a3c3d.pdf";